import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import SocialMedia from './SocialMedia';
import SitePerformance from './SitePerformance';
import SalePerformance from './SalePerformance';
import Ecommerce from './Ecommerce';
import FinanceDashboard from './FinanceDashboard';
import PageNotFound from '../404Error/PageNotFound';
import Widgets from './widgets';
import Reports from '../reports';
const ChartRouter = () => {

  return (
    <Routes>
      <Route index element={<Navigate to={"/dashboard/widgets"}/>} />
      <Route exact path="/socialmedia" element={<SocialMedia />} />
      <Route exact path="/ecommerce" element={<Ecommerce />} />
      <Route exact path="/siteperformance" element={<SitePerformance />} />
      <Route exact path="/New" element={<SalePerformance />} />
      <Route exact path="/finance" element={<FinanceDashboard />} />
      <Route exact path="/widgets" element={<Widgets />} />
      <Route exact path="/reports/*" element={<Reports />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes >
  )
}

export default ChartRouter;